import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isStartDiscussionRequestFailure({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isStartDiscussionRequestPending({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isStartDiscussionRequestSuccess({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
